import { baseForPdf } from '../apiClients';
import { Endpoints } from '../../network';
import { IResponse } from '../../utils/interfaces';

export interface IRouteBanner {
  _id: string;
  route: string[];
  text: string;
  textTab: string;
  textPhone: string;
  textColor: string;
  iconSvg: string;
  buttonText: string;
  buttonColor: string;
  buttonTextColor: string;
  link: string;
  expireIn: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const getRouteBanner = async (
  route: string,
): Promise<IResponse<IRouteBanner | null>> => {
  const response = await baseForPdf.get(Endpoints.getRouteBanner, {
    params: { route },
  });
  return response?.data;
};

export const getAllRouteBanners = async (): Promise<
  IResponse<IRouteBanner[]>
> => {
  const response = await baseForPdf.get(Endpoints.routeBanners);
  return response?.data;
};
